<template>
  <div class="logistics-order-panel">
    <div class="wrapper">
      <div v-if="order">
        <div style="height:0px; position:relative; top:-40px;">
          <button class="button toggle has-text-link is-rounded" @click="toggleHeight">
            <zoom-x-transition group :duration="1200">
              <i class="fa fa-chevron-down fa-lg" v-if="isTall" :key="1" />
              <i class="fa fa-chevron-up fa-lg" v-else :key="2" />
            </zoom-x-transition>
          </button>
        </div>

        <p style="position:absolute; margin-top:-40px; left:10px">
          <span class="tag is-medium is-info">{{ order.state }}</span>
        </p>
        <p style="position:absolute; margin-top:-40px; right:10px">
          <span
            class="tag is-medium is-warning"
            @click="transactionUpdatedInfo"
          >{{ updatedTimeAgo }}</span>
        </p>
        <div class="header is-size-5 has-text-weight-medium">
          <div class="columns is-mobile">
            <div class="column tab has-text-left" style="margin-left:10px;">
              <span class="has-text-dark">{{ businessName }}</span>
              <!-- <i class="fa fa-info-circle" style="margin-left:9px" @click="callBusiness" /> -->
            </div>
            <div class="column is-one-fifth wiggle" @click="shareOrder">
              <span class="button is-white is-rounded is-small share-btn">
                <i class="fa fa-paper-plane fa-lg has-text-info" />
              </span>
            </div>
          </div>
        </div>

        <div class="body">
          <div class="card">
            <div class="card-content">
              <p>
                <i class="fa fa-map-marker-alt has-text-primary" />
                &nbsp;{{ $t("driver.pickup-at") }}
                <a
                  :href="googleMapPickup"
                  target="_blank"
                >
                  {{ pickupName }}
                  <i class="fa fa-directions fa-lg" />
                </a>
              </p>
              <div v-if="t.data.dropoff_stop">
                <i class="fa fa-long-arrow-alt-down" />
                <p>
                  <i class="fa fa-map-marker-alt has-text-link" />
                  &nbsp;{{ $t("driver.dropoff-at") }}
                  <a
                    :href="googleMapDropoff"
                    target="_blank"
                  >
                    {{ dropoffName }}
                    <i class="fa fa-directions fa-lg" />
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-content has-text-left">
              <p>
                <i class="fa fa-clock has-text-primary" />
                &nbsp;{{ $t("logistics.pickup-time") }}:&nbsp;
                <span
                  class="has-text-link"
                >{{ pickupTime }} ({{ humanTimeOrTimeAgo }})</span>
              </p>
              <p>
                <i class="fa fa-box has-text-primary" />
                &nbsp;{{ $t("logistics.goods") }}:&nbsp;
                <span
                  class="has-text-link"
                >{{ goods }}</span>
              </p>
              <p>
                <i class="fa fa-coins has-text-primary" />
                &nbsp;{{ $t("logistics.value") }}:&nbsp;
                <span
                  class="has-text-link"
                >{{ currency }}{{ orderValue }}</span>
              </p>
            </div>
          </div>

          <collapse-transition>
            <div class="card" v-show="isTall">
              <div class="card-content has-text-left">
                <div class="transaction">
                  <div class="columns is-mobile is-vcentered">
                    <div class="column is-narrow ticket">
                      <img :src="profPic(t.driver)" />
                    </div>
                    <div class="column middle">
                      <div class="has-text-left">
                        <p>
                          <i class="fa fa-truck pad" />
                          <span>{{ order.workflow.name }}</span>&nbsp;
                          <span class="tag is-dark is-pulled-right">ABC415</span>
                        </p>
                        <p>
                          <i class="fa fa-user pad" />
                          <span>{{ t.driver.name }}</span>
                        </p>
                        <p>
                          <i class="fa fa-phone pad" />
                          <span @click="callPhoneNumber(t.driver.phone_number)">
                            {{ t.driver.phone_number }}
                            <span
                              class="tag is-rounded is-success"
                              style="padding:6px"
                            >
                              <i class="fa fa-phone" />
                            </span>
                          </span>
                          <span
                            class="tag is-pulled-right"
                            @click="driverUpdatedInfo"
                          >{{ timeAgo(t.driver.user_state.updated_at) }}</span>
                        </p>
                        <!-- <p>
                      <i class="fa fa-coins pad" />
                      <span class="has-text-weight-medium">{{currency}}{{ farePrice(t) }}</span>
                        </p>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </collapse-transition>
        </div>
      </div>

      <div v-else>
        <div class="header is-size-5 has-text-primary has-text-weight-medium">
          <div class="columns is-mobile">
            <div class="column tab has-text-left" style="margin-left:10px;">
              <span>Fetching Order Details...</span>
            </div>
            <div class="column is-one-fifth">
              <i class="fa fa-spinner fa-spin" />
            </div>
          </div>
        </div>
        <!-- <div class="body has-text-link"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import { sounds } from "../functions.js";

export default {
  name: "LogisticsOrderPanel",
  components: {},
  props: {
    order: Object
  },
  data() {
    return {
      driverPollInterval: null,
      isTall: false
    };
  },
  computed: {
    t() {
      return this.order;
    },
    businessName() {
      return this.order.business.name;
    },
    role() {
      return this.$store.getters.getDriverRole;
    },
    isDispatcher() {
      return this.isWorkingDispatcher();
    },
    pickupName() {
      return this.shortenString(this.t.data.pickup_stop.name, 40);
    },
    dropoffName() {
      return this.shortenString(this.t.data.dropoff_stop.name, 40);
    },
    googleMapPickup() {
      var a = this.t.data.pickup_stop;
      return `http://www.google.com/maps/place/${a.lat},${a.lon}`;
    },
    googleMapDropoff() {
      var a = this.t.data.dropoff_stop;
      return `http://www.google.com/maps/place/${a.lat},${a.lon}`;
    },
    goods() {
      return this.t.data.delivery.goods;
    },
    orderValue() {
      return this.t.data.delivery.order_value;
    },
    currency() {
      return this.currencySymbol(this.order.business.country);
    },
    pickupTime() {
      return this.shortDateTime(this.order.data.scheduled_time);
    },
    humanTimeOrTimeAgo() {
      var t = this.order;
      if (this.humanTime(t) !== "Passed") return this.humanTime(t);
      return this.timeAgo(t.data.scheduled_time);
    },
    updatedTimeAgo() {
      return this.timeAgo(this.order.updated_at);
    },
    minsAgo() {
      var minsAgo = (new Date() - new Date(this.t.updated_at)) / (1000 * 60);
      // if (minsAgo < 90) return `76 mins ago` // e.g.
      // 1.6 hours ago
      return Math.round(minsAgo);
    }
    // pickupDirectionsURL() {
    //   if (!this.t.data.pickup_stop) return;
    //   var current = this.$store.state.userState;
    //   var scoords = `${current.lat},${current.lon}`;
    //   var dcoords = `${this.t.data.pickup_stop.lat},${this.t.data.pickup_stop.lon}`;
    //   return `https://www.google.com/maps?saddr=${scoords}&daddr=${dcoords}`; //url + coords;
    // }
  },
  created() {
    this.console("DriverPanel.vue created");
    this.$store.subscribe(mutation => {
      if (mutation.type === "setTransactionsForWorker") {
        if (this.hasCancelledTransactions) {
          EventBus.$emit("CLOSE_PASSENGER_DETAIL", true);
        }
        this.checkAcknowledgeRequired();
        // this.checkETARequired(); // TODO popup ETA input for driver if necessary
        if (this.hasNewWorkerTransactions) {
          this.updateDriversAutocomplete(); // only for dispatcher
          this.hasNewPassenger = true;
          this.newTransactions = this.$store.getters.getWorkerTransactionsStateNew;
          // EventBus.$emit("CLOSE_PASSENGER_DETAIL", true);
          setTimeout(() => EventBus.$emit("DRIVER_FIT_LAYER"), 600);
        } else {
          this.hasNewPassenger = false;
        }
      }
    });
  },
  mounted() {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") return;
      this.updateTransactionsForDriver(true); // force update transactions whenever driver comes to this page
    });
  },
  activated() {
    this.pollTransactions();
    this.updateTransactionsForDriver(true); // force update transactions whenever driver comes to this page
  },
  beforeDestroy() {
    if (this.driverPollInterval) clearInterval(this.driverPollInterval);
  },
  methods: {
    toggleHeight() {
      this.isTall = !this.isTall;
    },
    transactionUpdatedInfo() {
      var ago = this.timeAgo(this.t.updated_at);
      this.infoToast(`Transaction updated ${ago}`);
    },
    driverUpdatedInfo() {
      var ago = this.timeAgo(this.t.driver.user_state.updated_at);
      this.infoToast(`Driver last updated ${ago}`);
    },
    callBusiness() {
      this.callPhoneNumber(this.order.business.phone_number);
    },
    shareOrder() {
      var shortID = this.order.data.delivery.short_link;
      if (!shortID) return this.errorToast("No shareable link!", "top");
      var url = process.env.VUE_APP_HOST;
      var shortLink = `${url}/q/${shortID}`;
      this.$copyText(shortLink);
      this.infoToast("Share Job, Link Copied", "top"); // copied to clipboard
      if (!navigator.share) {
        var txt = `Sharing not supported by this device.<br><br>Send as SMS or paste into a chat.`;
        return this.warningAlert(txt);
      }
      var msg = this.$t("TUK Logistics📦 Click link to see your order!🎉");
      navigator
        .share({ text: msg, url: shortLink })
        .then(() => console.log("Successful share"))
        .catch(err => console.log("Error sharing", err));
    },
    checkAcknowledgeRequired() {
      var txns = this.$store.getters.getWorkerTransactionsStateConfirmed;
      var t = txns.find(
        t =>
          t.data.hasOwnProperty("acknowledged") &&
          !t.data.acknowledged &&
          t.handled_by === this.userID() &&
          !this.acknowledged[t.id]
      );
      if (!t) return; // no transactions require acknowledgement
      var txt = this.$t("driver.please-acknowledge");
      this.$swal({
        title: `${this.$t("driver.new-dispatch")}<br>${txt}<br>👌🏼`,
        text: this.$t("driver.if-unable-cancel")
      }).then(() => {
        this.acknowledged[t.id] = true;
        this.$store
          .dispatch("patchTransaction", {
            transactionID: t.id,
            data: { data: { acknowledged: true } }
          })
          .catch(err => {
            this.acknowledged[t.id] = false;
            console.error("acknowledge dispatch", err);
          });
        this.thankYou();
      });
    },
    updateDriversAutocomplete() {
      if (!this.isWorkingDispatcher()) return; // only do for Dispatcher
      if (this.$store.getters.getWorkingRole) {
        var workflowID = this.$store.getters.getWorkingRole.workflow_id;
        this.$store
          .dispatch("autocompleteDriverWorkflows", workflowID)
          .catch(err => console.error("updateDriversAutocomplete", err));
      }
    },
    pollTransactions() {
      console.log("pollTransactions DriverPanel2");
      this.updateTransactionsForDriver(false); // trigger straight-away
      // then check if driver poll has been set up or not yet
      if (!this.driverPollInterval) {
        this.driverPollInterval = setInterval(() => {
          this.updateTransactionsForDriver(false); // re-trigger on interval
        }, 1000 * 30); // ping ever 10 seconds
      }
    },
    showHistory() {
      sounds("money");
      this.displayModal(".driver-history-modal");
      EventBus.$emit("DRIVER_HISTORY", this.role.workflow_id);
      //   var workflowID = this.$store.state.workingRole.workflow_id;
      //   if (this.isDispatcher) {
      //     this.displayModal(".dispatcher-history-modal");
      //     EventBus.$emit("DISPATCHER_HISTORY", workflowID);
      //   } else {
      // this.displayModal(".driver-history-modal");
      // EventBus.$emit("DRIVER_HISTORY", workflowID);
      //   }
    }
  }
};
</script>

<style scoped>
.wrapper {
  z-index: 1;
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: auto;
  min-height: 255px;
  max-height: 80vh;
  width: 100%;
}
.header {
  padding: 6px;
  background-color: #f5d252;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  box-shadow: 0px -1px 1px rgba(100, 100, 100, 0.2);
}
.column.tab {
  padding-right: 0;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(247, 211, 8, 0.5);
  }
}
.pulse {
  animation: shadow-pulse 1s infinite;
  border-radius: 50%;
}
.toggle {
  padding: 5px 8px;
  /* border-top-right-radius: 50%;
  border-top-left-radius: 50%; */
  background-color: #feeaa4;
  filter: drop-shadow(2px 2px 2px #666);
}
.card-content {
  padding: 12px;
}
.share-btn {
  padding: 5px;
  font-size: 10pt;
  box-shadow: 1px 1px 1px grey;
}

.transaction {
  /* background-color: white; */
  /* position: relative; */
  /* border-radius: 10px; */
  /* border: 1px solid lightgrey; */
  /* box-shadow: 0px 1px 1px lightgrey; */
}
.transaction img {
  height: 75px;
  width: 75px;
  border-radius: 10px;
  border: 1px solid gold;
}
.middle {
  padding-left: 0;
}
.pad {
  width: 16px;
  margin-right: 12px;
}
</style>